<template>
  <div class="account_address" :class="theme_type">
    <div class="container">
      <div class="row ">
        <div class="col-md-5 col-12 address">
          <ul>
            <li v-for="(item,index) in address_list" :key="item.id">
              <v-addressitem :theme_type="theme_type" :service="service" :addressitem="item"></v-addressitem>
              <p class="address-item-buttom">
                <a  @click="editAddress(item)" class="text-uppercase"  href="#">{{$t('account.edit')}}</a>
                <a  @click="deleteButton(item.id ,index)" class="text-uppercase" href="#">{{$t('account.delete')}}</a>
              </p>
            </li>
          </ul>
        </div>
        <div class="col-md-7 col-12 edit_address">
          <div class="address-item-buttom" v-if='!addresses && !addressitem.show'>
            <a href="#" @click="addresses=!addresses" class="text-uppercase">{{$t('account.add_new_address')}}</a>
            <!-- 切换显示隐藏 -->
          </div>
          <v-addressfrom
            v-if="addresses"
            @hiddenform="addresses=!addresses"
            :service="service"
            :address_list="address_list"
          ></v-addressfrom>
          <v-addressfrom
            :update="addressitem"
            v-if="addressitem.show"
            @hiddenform="addressitem.show = !addressitem.show"
            :service="service"
            :address_list="address_list"
          ></v-addressfrom>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('account.warning')" :visible.sync="dialogVisible">
      <span class="secondary_title">
        <i class="iconfont" style="color:red;">&#xe601;</i>
        {{$t('account.sure_delete_address')}}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="secondary_title" @click="dialogVisible = false" style="background-color:white !important;color:#606266 !important; border-color:#DCDFE6 !important;">{{$t('account.cancel')}}</el-button>
        <el-button
         class="main_button secondary_title"
          type="primary"
          @click="deleteaddress"
          :loading="loading"
        >{{$t('account.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import vAddressfrom from "./addressfrom";
import vAddressitem from "./addressitem";
import vAccounttop from "./accounttop";
// import API from "../../../../../js/API.js";

export default {
  props: ["address_book", "service", "theme_type"],
  data() {
    return {
      addresses: false,
      address_list: [],
      addressitem:{},
      dialogVisible: false,
      id: "",
      index: "",
      loading: false,
      isphone: this.$(window).width() <= 575
    }
  },
  methods:{
    editAddress(val){
      this.addresses = false
      val.show = !val.show
      this.addressitem = val
      console.log(this.addressitem);
    },
    async deleteaddress(id, index) {
      try {
        this.loading = true;
        let res = await this.$axios.delete(API.deleteaddress + this.id);
        this.address_book.splice(this.index, 1);
        this.dialogVisible = false;
        this.loading = false;
        const tip = this.$t("account.deleted_successfully");
        this.$message.success(tip);
      } catch (error) {
        this.dialogVisible = false;
        if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },
    deleteButton(id, index) {
      this.dialogVisible = true;
      this.id = id;
      this.index = index;
    }
  },
  mounted() {
    this.address_list = this.address_book;
    this.address_list.forEach(item => {
      this.$set(item, "show", false); //起作用
    });
  },
  components: {
    vAddressfrom,
    vAddressitem,
    vAccounttop,
  }
};
</script>
<style scoped  lang='scss'>
.account_address {
  margin-top: 30px;
  margin-bottom: 42px;
  .container {
    .tiny {
      max-width: 740px;
      text-align: center;
    }
    .section_title {
      margin: 0 auto 18px;
      border-bottom: 1px solid #cccccc;
      display: flex;
      align-items: center;
      padding: 20px 0;
      justify-content: space-between;
      .title{
        height: 32px;
        font-size: 42px;
        font-family: Roboto;
        font-weight: bold;
        color: #222A40;
        line-height: 42px;
      }
      div{
        display: flex;
        button,span {
          height: 16px;
          font-size: 16px;
          font-family: Roboto;
          font-weight: 500;
          text-decoration: none;
          color: #222940;
          line-height: 42px;
        }
        button,.return-account {
          text-decoration: underline;
        }
      }
    }
    .row{
      margin-top: 50px;
      .address{
        padding-right: 50px;
        border-right: 1px solid #cccccc;
        .address-item-buttom{
          width: 100%;
          display: flex;
          text-align: center;
          a{
            width: 50%;
            display: inline-block;
            text-decoration: none;
            background-color: #222A40;
            color: #FFFFFF;
            border-color: transparent ;
            font-size: 24px;
            font-family: Roboto;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 42px;
          }
          a:first-child{
             margin: 10px 10px 10px 0;
          }
          a:last-child{
            margin: 10px 0px 10px 10px;
            background-color: #ffffff;
            color: #222A40;
            border: 1px solid #222A40 ;
          }
          .btn_ban{
            pointer-events:none;
          }
        }
      }
      .edit_address{
        padding-left: 50px;
        .address-item-buttom{
            text-align: left;
          a{
            text-align: center;
            width: 50%;
            display: inline-block;
            text-decoration: none;
            background-color: #222A40!important;
            color: #FFFFFF!important;
            border-color: transparent !important;
            font-size: 24px;
            font-family: Roboto;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 42px;
          }
        }
      }
    }
    h2 {
      font-size: 20px;
    }
  }
}
@media screen and (max-width: 768px){
  .account_address{
    .container{
      .section_title{
        flex-direction: column;
        .title{
          font-size: 18px !important;
          line-height: normal !important;
          height: auto !important;
        }
        div{
          margin-top: 25px;
          flex-direction: row;
          justify-content: flex-start;
          width: 100%;
          .return-account{
            margin-right: 30px;
          }
          button,span {
            height: auto !important;
            font-size: 13px !important;
            line-height: normal !important;
          }
        }
      }
      .row{
        margin-top: 25px !important;
        .address{
          padding: 0 15px !important;
          .address-item-buttom{
            a{
              background-color: #ffffff !important;
              color: #222A40!important;
              border: 1px solid #222A40 !important;
              margin-top: 15px !important;
              margin-bottom: 15px !important;
            }
          }
        }
        .edit_address{
          padding: 0 15px !important;
          .address-item-buttom{
            width: 100% !important;
            a{
              width: 100% !important;
              font-size: 15px !important;
            }
          }
          &::v-deep{

            .addressform_body{
              margin: 0 !important;
              .row{
                margin-top: 25px !important;
                .form_item_lable{
                  font-size: 14px !important;
                  line-height: 21px !important;
                  margin-bottom: 12px !important;
                }
                .page_text_font{
                  height: 40px !important;
                  background: #FFFFFF !important;
                  border: 1px solid #CCCCCC !important;
                }
                .error {
                  font-size: 12px !important;
                  margin-top: 5px;
                  color: #e32c2b;
                }
                input,select {
                  width: 100%;
                  padding: 8px 10px;
                  background: #f7f7f7;
                  border: none;
                }
              }
            }

            .addressform_default{
              margin-top: 15px !important;
              .setdefaultbox{
                width: 14px !important;
                height: 14px !important;
              }
              .set_default{
                font-size: 13px !important;
                line-height: 21px !important;
              }
            }

            .showtime_button{
              display: flex;
              flex-direction: column;
              align-items: center;
              button,a{
                text-align: center;
                width: 100%;
                margin: 0;
              }
              span,a{
                font-size: 15px !important;
              }
            }
          }
        }
      }
    }
  }
}

</style>
